import { yup } from '@jbc-year-end-adj/common/yup';
import { Profile } from './query';

const maritalStatuses = ['unmarried', 'married', 'divorced_or_bereavement'];
export type MaritalStatus = typeof maritalStatuses[number];

const classifications = ['none', 'normal', 'special', 'single_parent'];
export type Classification = typeof classifications[number];

export type Schema = {
  maritalStatus: MaritalStatus;
  classification: Classification;
};

export const schema = yup.object({
  maritalStatus: yup
    .mixed<MaritalStatus>()
    .oneOf(maritalStatuses)
    .required(),
  classification: yup
    .mixed<Classification>()
    .oneOf(classifications)
    .required()
});

export const buildDefaultValue = (profile: Profile) => {
  return {
    maritalStatus: profile.maritalStatus,
    classification: profile.widowClassification?.classification || 'none',
    detail: profile.widowClassification?.detail
  };
};
